import $ from 'jquery';
// import gsap from 'gsap';
// import ScrollTrigger from 'gsap/ScrollTrigger.js';

(() => {


  // gsap.to('.ot__recommend--inner',{x:0,y:100,
  //   ScrollTrigger:{
  //     trigger:'.ot__recommend--inner',
  //     start:'top 80%',
  //     end:'bottom 20%',
  //     markers:true,
  //     toggleActions:'play none none reverse',
  //   }
  // });


  $(window).scroll(function () {
    $('.effect').each(function () {
      var hit = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var wHeight = $(window).height();
      var customTop = wHeight * 0.5;
      if (typeof $(this).data('effect') !== 'undefined') {
        // data-effect="任意の値" が設定されている場合
        customTop = $(this).data('effect');
      }
      if (hit + customTop < wHeight + scroll) {
        $(this).addClass("is-active");
      // } else {
      //   $(this).removeClass("is-active");

      }
    });
  });



  
})();
